import request from "@/utils/request";

//行程记录
export function listMonthlyTrackRecord(data) {
  return request({
    url: "/scooter/listMonthlyTrackRecord",
    method: "post",
    data,
  });
}

//获取某条行程记录详情
export function getPerTrackRecordDetail(data) {
  return request({
    url: "/scooter/getPerTrackRecordDetail",
    method: "post",
    data,
  });
}

//删除行程记录
export function delTrackRecord(data) {
  return request({
    url: "/scooter/delTrackRecord",
    method: "post",
    data,
  });
}
